<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Register</title>
    <link rel="stylesheet" href="styles.css">
</head>

<body>

    <div class="container">
        <div class="form-container">
            <h1 class="register-header">Register</h1>

            <form [formGroup]="registerForm" (ngSubmit)="register()">

                <label>Username</label>
                <input type="text" formControlName="username" required>
                <div *ngIf="registerForm.get('username')?.invalid && registerForm.get('username')?.touched">
                    Username is required
                </div>
                <label>Email</label>
                <input type="email" formControlName="email" required>
                <div *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">
                    Email is required
                </div>



                <label>Password</label>
                <input type="password" formControlName="password" required>
                <div *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
                    <div *ngIf="registerForm.get('password')?.hasError('minlength')" class="error-message">
                        <i class="error-icon">❌</i> Password must be at least 8 characters.
                    </div>
                    <div *ngIf="registerForm.get('password')?.hasError('uppercase')" class="error-message">
                        <i class="error-icon">❌</i> Password must contain at least one uppercase letter.
                    </div>
                    <div *ngIf="registerForm.get('password')?.hasError('lowercase')" class="error-message">
                        <i class="error-icon">❌</i> Password must contain at least one lowercase letter.
                    </div>
                    <div *ngIf="registerForm.get('password')?.hasError('specialCharacter')" class="error-message">
                        <i class="error-icon">❌</i> Password must contain at least one special character.
                    </div>
                </div>

                <label>Confirm Password</label>
                <input type="password" formControlName="confirmPassword" required>
                <div
                    *ngIf="registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched">
                    <div *ngIf="registerForm.get('confirmPassword')?.hasError('passwordMismatch')"
                        class="error-message">
                        <i class="error-icon">❌</i> Passwords do not match.
                    </div>
                </div>





                <label>Service Request ID</label>
                <input type="text" formControlName="serviceRequestId" (blur)="checkServiceRequest()" required>
                <div *ngIf="serviceRequestValid === false">
                    ❌ Invalid Service Request ID
                </div>
                <div *ngIf="checkingServiceRequest">
                    🔄 Checking...
                </div>

                <button type="submit" [disabled]="registerForm.invalid || serviceRequestValid === false"
                    class="register-button">
                    Register
                </button>
            </form>

            <p>Already have an account? <a href="https://appointment.mhnexus.com"> Login</a></p>
        </div>
        <div class="image-container">
            <h2>Welcome!</h2>
        </div>

    </div>

</body>

</html>